module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/jss/~/symbol-observable/index.js
// module id = 36
// module chunks = 0